import { render, staticRenderFns } from "./app.product.page.vue?vue&type=template&id=17bbe7cd&scoped=true&"
import script from "./app.product.page.vue?vue&type=script&lang=js&"
export * from "./app.product.page.vue?vue&type=script&lang=js&"
import style0 from "./app.product.page.vue?vue&type=style&index=0&id=17bbe7cd&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bbe7cd",
  null
  
)

export default component.exports